<template>
  <ion-page>
    <master-layout pageTitle="محصول">

      <Loading :is="!productLoaded" v-if="!productLoaded"></Loading>
      <div v-if="productLoaded">
        <div v-if="product">
          <ion-card>
            <ion-card-content>
              <h1 class="product-p-title center mt-2">
                {{ product.title }}
              </h1>
              <h2 class="text-left english-title small font-weight-bold ml-2">
                {{ product.english_title }}
              </h2>
              <div class="img">
                <img v-if="defaultProvider && defaultProvider.thumbnail" :src="defaultProvider.thumbnail.url"
                     :alt="product.title">
                <img v-else-if="thumbnail_url" :src="thumbnail_url" :alt="product.title">
                <img v-else :src="product.thumbnail.url" :alt="product.title">
              </div>

              <div class="d-inline border-left ml-1 mr-2">برند : <a class="border-0"
                                                                    href="{{product.brand.link}}">
                {{ product.brand.title }}</a>
              </div>
              <div class="d-inline">دسته بندی : <a class="border-0"
              >{{ product.main_category.title }}</a>
              </div>

              <div v-if="product.product_type === 'variable'" class="attributes-select mt-1">
                <div v-if="variable_attributes.length" class="attributes-select">

                  <div v-for="(attr,index) in variable_attributes" :key="index">
                    <div class="attr-title">
                      <span>انتخاب {{ attr.title }} :</span>
                    </div>
                    <div class="attr-select mt-1">
                      <select @change="changeAttr(index,$event.target.value)" autocomplete="off" class="form-control"
                              name="attr">
                        <option :selected="index2 ===0" v-for="(value,index2) in attr.values" :key="index2"
                                :value="value.obj_str">
                          {{ value.title }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class=" seller-info mt-1">
                <Seller :wait_btn="wait_btn"
                        :product-id="product._id"
                        :provider="defaultProvider"
                        :change-unit="changeUnit" :addToCart="addToCart"></Seller>
              </div>
              <div v-if="other_providers.length > 1" id="other_providers" class="mb-2 mr-2 mt-3">
                <div>دیگر فروشندگان این محصول :</div>
                <div class="table-responsive">
                  <ion-grid>
                    <ion-row class="other_provider_table center" v-for="(provider,index) in other_providers"
                             :key="index">
                      <ion-col size="12">
                        {{ provider.name }}
                        <div>{{ provider.attr_string }}</div>
                      </ion-col>
                      <ion-col size="6">
                        <div v-if="provider.special_price">
                          <label>قیمت : </label>
                          <money :number="provider.special_price"></money>
                          <div class="special_info">
                            <del>
                              <money :number="provider.price"></money>
                            </del>
                            <span class="price_percent">{{ provider.special_price_percent }} %</span>
                          </div>
                        </div>
                        <div v-else>
                          <label>قیمت : </label>
                          <Money :number="provider.price"></Money>
                        </div>
                      </ion-col>
                      <ion-col size="6">
                        <ion-button @click="addToCartOtherProvider(index)" expand="full" color="success">
                          <span v-if="!wait_btn">افزودن به سبد</span>
                          <span v-if="wait_btn"><i class="far fa-spin fa-spinner"></i></span>
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
          <div class="info_menu">
            <div :class="(current_tab === 'content')?'active_div':''" @click="current_tab = 'content'"
                 v-if="product.original_content !== '' || product.short_content !== ''">توضیحات
            </div>
            <div :class="(current_tab === 'option')?'active_div':''" @click="current_tab = 'option'">مشخصات فنی</div>
            <div :class="(current_tab === 'tech_codes')?'active_div':''" @click="current_tab = 'tech_codes'"
                 v-if="product.tech_codes.length">کدهای فنی
            </div>
            <div :class="(current_tab === 'car_usage')?'active_div':''" @click="current_tab = 'car_usage'">
              مورد استفاده
            </div>
          </div>

          <div v-if="product_content && current_tab === 'content'" id="product_content_text"
               class="p-2">
            <ion-card>
              <ion-card-content>
                <h6 class="mt-2 d-grid"><strong>توضیحات محصول</strong></h6>
                <br/>
                <div class="position-relative" v-html="product.short_content">
                </div>
                <br/>
                <div class="product-content" v-html="product.original_content">

                </div>
              </ion-card-content>
            </ion-card>
          </div>

          <div v-if="current_tab === 'option'" id="product_option_text"
               class="ion-padding">
            <div v-for="(attr,index) in product.attributes" :key="index">
              <h5 class="title mt-3"><span
                  class="fa fa-caret-left product-info-title">&nbsp;</span>{{ attr.name }}</h5>
              <div class="attribute-group mt-3">
                <div class="table-responsive">
                  <table class="table table-striped">
                    <tbody>
                    <tr v-for="(item,index2) in attr.values" :key="index2">
                      <th>
                        <div class="attribute d-block bg-light p-2">
                          {{ item.title }}
                        </div>
                      </th>
                      <td>
                        <div class="value bg-light p-2 mr-2 d-block">
                            <span v-for="(val,index) in item.value" :key="index">
                            {{ val }}
                              </span>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="current_tab === 'tech_codes'" id="product_tech_code_text" class="ion-padding">
            <h2 class="tech-code-title">کد های فنی &nbsp;"{{ product.title }}"</h2>
            <div class="table-responsive">
              <table class="table table-striped">
                <tbody>
                <tr v-for="(item,index) in product.tech_codes" :key="index" class="row">
                  <td>
                    <div class="attribute d-block bg-light">
                      {{ item.title }}
                    </div>
                  </td>
                  <td>
                      <span class="value" v-for="(v,i) in item.value" :key="i">
                        {{ i > 0 ? ', ' : '' }}{{ v }}
                      </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="current_tab==='car_usage'">
            <ion-card>
              <ion-card-content>
                <div class="table-responsive">
                  <div class="tree well" v-for="(b,bIndex) in product.cars_info" :key="bIndex">
                    <ul>
                      <li :class="(b.models && b.models.length)?'parent_li':''">
                        <span><i class="fal fa-plus-circle"></i></span>
                        <router-link :to="'/cars/brand/'+b.brand_id">
                          <img :src="b.pic_url" class="related_car_pic">
                          <strong>{{ b.title }}</strong>
                        </router-link>
                        <ul v-for="(m,mIndex) in b.models" :key="mIndex">
                          <li style="display: none" :class="(m.types && m.types.length)?'parent_li':''">
                            <span><i class="fal fa-plus-circle"></i> </span>
                            <router-link :to="'/cars/model/'+m.model_id">
                              <img :src="m.pic_url" class="related_car_pic">
                              <strong>{{ m.title }}</strong>
                            </router-link>
                            <ul v-for="(c,cIndex) in m.types" :key="cIndex">
                              <li style="display: none;">
                                <span><i class="fal fa-car-side"></i> </span>
                                <router-link :to="'/cars/type/'+c._id">
                                  <img :src="c.pic_url" class="related_car_pic">
                                  <strong>{{ c.title }}</strong>
                                </router-link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
          </div>

        </div>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
      </div>

    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import sha1 from 'js-sha1';
import Loading from "@/components/Loading";
import Money from "@/components/Money";
import AliSelect from "@/components/aliSelect";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";
import Seller from "@/components/Seller";
import {showSystemNoti} from "@/shared/helper";

export default {
  data()
  {
    return {
      id: null,
      productLoaded: false,
      product: null,
      error: null,
      defaultProvider: null,
      variable_attributes: null,
      providers: [],
      unit_type: 'small',
      used_variable: [],
      thumbnail_url: null,
      product_content: true,
      product_option: false,
      product_tech_code_text: false,
      wait_btn: false,
      current_tab: 'content',
      other_providers: []
    };
  },
  created()
  {
    this.init()
  },
  components: {
    AjaxForm,
    Loading,
    AliSelect,
    Money,
    AliAjaxSelect,
    Seller,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    async init()
    {
      this.productLoaded = false;
      this.product = null;
      this.defaultProvider = null;
      this.id = this.$route.params.id;
      const result = await this.getProduct(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.productLoaded = true;
          const product = result.product;

          setTimeout(function ()
          {
            window.$(document).ready(function ()
            {
              var $ = window.$;

              if (!window.productPageRendered)
              {
                window.productPageRendered = true
                $(this).delegate('.tree li.parent_li > span', 'click', function (e)
                {
                  var children = $(this).parent('li.parent_li').find(' > ul > li');
                  if (children.is(":visible"))
                  {
                    children.hide('fast');
                    $(this).attr('title', 'Expand this branch').find(' > i').addClass('fa-plus-circle').removeClass('fa-minus-circle');
                  }
                  else
                  {
                    children.show('fast');
                    $(this).attr('title', 'Collapse this branch').find(' > i').addClass('fa-minus-circle').removeClass('fa-plus-circle');
                  }
                  e.stopPropagation();
                });
              }
            })
          }, 300);

          if (product.product_type === 'variable')
          {
            this.used_variable = JSON.parse(product.used_variable_json);
            let variable_attributes = product.variable_attributes;
            for (let i = 0; i < variable_attributes.length; i++)
            {
              let values = variable_attributes[i].values;
              values[0].selected = true;
              variable_attributes[i].values = values;
            }
            this.variable_attributes = variable_attributes;
            product.variable_attributes = variable_attributes;
          }
          product.date = new Date().getTime();
          this.defaultProvider = product.defaultProvider;
          this.providers = product.providers;
          this.product = product;
          this.setOtherProviders();
        }
        else
        {
          this.productLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.productLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    ...mapActions("shop", {
      addToCartFunc: 'addToCart',
      getProduct: 'getProduct'
    }),
    setOtherProviders()
    {
      const providers = this.product.providers;
      const defaultProvider = this.defaultProvider;
      if (!defaultProvider)
      {
        this.other_providers = [];
        return;
      }
      if (this.product.product_type === 'variable')
      {
        const other_provider = [];
        const hash = defaultProvider.attr_hash;
        for (let i = 0; i < providers.length; i++)
        {
          if (providers[i].attr_hash === hash)
          {
            other_provider.push(providers[i]);
          }
        }
        this.other_providers = other_provider;
      }
      else
        this.other_providers = this.product.providers;
    },
    changeAttr(index, obj_str)
    {
      const current = this.variable_attributes[index];
      for (let i = 0; i < current.values.length; i++)
      {
        if (current.values[i].obj_str === obj_str)
          current.values[i].selected = true;
        else
          current.values[i].selected = false;
      }
      this.getCurrentHashAttr();

    },
    getCurrentHashAttr(just_hash = false)
    {
      let end_attr = [];
      const v_attr = this.variable_attributes;
      for (let i = 0; i < v_attr.length; i++)
      {
        const values = v_attr[i].values;
        for (let j = 0; j < values.length; j++)
        {
          if (values[j].selected)
          {
            end_attr.push(JSON.parse(values[j].obj_str));
            break;
          }
        }
      }
      //یک لیست تامین کننده

      const hash = sha1(JSON.stringify(end_attr));
      if (just_hash)
        return hash;
      const used_variable = this.used_variable;
      for (let i = 0; i < used_variable.length; i++)
      {
        if (used_variable[i].attr_hash === hash)
        {
          this.thumbnail_url = used_variable[i].thumbnail.url;
        }
      }
      let p_providers = this.product.providers;
      const providers = [];
      for (let i = 0; i < p_providers.length; i++)
      {
        if (p_providers[i].attr_hash === hash)
        {
          providers.push(p_providers[i]);
        }
      }
      let default_provider = null;
      let c_price = 0;
      if (providers.length)
      {
        for (let i = 0; i < providers.length; i++)
        {
          if (!c_price)
            c_price = providers[i].price + 1;
          if (c_price > providers[i].price)
          {
            default_provider = providers[i];
            c_price = providers[i].price;
          }
        }

        this.defaultProvider = default_provider;
        this.setOtherProviders();
      }
      else
      {
        this.defaultProvider = null;
        this.setOtherProviders();
      }
    },
    async addToCart()
    {
      const self = this;
      const out = {};
      out.product_id = this.product._id;
      out.product_type = this.product.product_type;
      if (this.product.product_type === 'variable')
      {
        out.hash = this.getCurrentHashAttr(true);
      }
      else
        out.hash = null;
      if (this.defaultProvider)
      {
        out.provider_id = this.defaultProvider.provider_id;
      }
      else
        out.provider_id = 1;
      out.unit_type = this.unit_type;
      out.quantity = 1;
      out.type = 'increase';

      this.wait_btn = true;
      const check = await this.addToCartFunc(out);
      this.wait_btn = false;
      if (check.ok)
      {
        self.$router.push({path: '/ShopCart'});
      }
      else
        return showSystemNoti('danger', check.error);
    },
    async addToCartOtherProvider(index)
    {
      const provider = this.other_providers[index]
      const self = this;
      const out = {};
      out.product_id = this.product._id;
      out.product_type = this.product.product_type;
      if (this.product.product_type === 'variable')
      {
        out.hash = this.getCurrentHashAttr(true);
      }
      else
        out.hash = null;

      out.provider_id = provider.provider_id;
      out.unit_type = this.unit_type;
      out.quantity = 1;
      out.type = 'increase';

      this.wait_btn = true;
      const check = await this.addToCartFunc(out);
      this.wait_btn = false;
      if (check.ok)
      {
        self.$router.push({path: '/ShopCart'});
      }
      else
        return showSystemNoti('danger', check.error);
    },
    changeUnit(event)
    {
      this.unit_type = event.target.value;
    }
  }, watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('shopproduct') >= 0)
        {
          this.loading = true;
          this.init()
        }
      }
    },
    unit_type()
    {
      const unit_type = this.unit_type;
      const providers = this.providers;
      if (providers)
      {
        for (let i = 0; i < providers.length; i++)
        {
          if (unit_type === 'small')
          {
            providers[i].price = providers[i].price / providers[i].bigger_unit_quantity;
            if (providers[i].special_price)
              providers[i].special_price = providers[i].special_price / providers[i].bigger_unit_quantity;

          }
          else
          {
            providers[i].price = providers[i].price * providers[i].bigger_unit_quantity;
            if (providers[i].special_price)
              providers[i].special_price = providers[i].special_price * providers[i].bigger_unit_quantity
          }
        }
        this.providers = providers;

      }
    },
  }
};

</script>

<style scoped>
.h5 {
  font-weight: 900;
  font-size: 14px;
  align-self: center;
  color: #000000b3;
  font-weight: bold;
}

.other_provider_table > ion-col {
  border: 1px solid white;
}

.other_provider_table {
  background: #ebeaff;
  margin-bottom: 5px;
  color: #222;
}

.special_info {
  direction: ltr;
}

.price_percent {
  background: #dc3545;
  border-radius: 6px;
  font-size: 12px;
  color: white;
  margin-left: 4px;
}

.info_menu {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  box-shadow: 0 5px 5px 0 rgba(140, 140, 140, 0.5);
  white-space: nowrap;
  width: 100%;
  overflow-x: auto;
}

.info_menu > div {
  border-bottom: 1px solid silver;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  min-width: 75px;
}

.back_gray {
  background: #f0f2f9;
}

.active_div {
  color: #dc3545;
  border-bottom: 3px solid #dc3545 !important;
  font-weight: 900 !important;
}

.p-2 {
  padding: 5px;
}

h1 {
  font-size: 18px !important;
  text-align: center;
}

h2.english-title {
  text-align: center;
  font-size: 14px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.tech-code-title {
  font-size: 14px;
  font-weight: bold;
  padding: 15px;
  line-height: 25px;
  margin-bottom: 0;
  padding-bottom: 0;
}

.product-content {
  font-weight: lighter;
  line-height: 24px;
}

.related_car_pic {
  max-width: 35px;
  max-height: 40px;
  border-radius: 5px;
}

.parent_li ul .related_car_pic{
  position: relative;
  top: -7px;
}

.tree {
  min-height: 20px;
  margin-bottom: 10px;
  border-bottom: 1px solid gainsboro;
  padding-bottom: 10px;
}

.tree li {
  list-style-type: none;
  margin: 0;
  padding: 10px 5px 0 5px;
  position: relative;
  white-space: nowrap;
}

.tree li span {
  display: inline-block;
  text-decoration: none;
  font-size: 25px !important;
  position: relative;
  bottom: 10px;
  margin-left: 10px;
  color: #595959;
  font-weight: bold;
}

.tree li.parent_li > span {
  cursor: pointer;
}

.tree li::before, .tree li::after {
  content: '';
  right: -8px;
  position: absolute;
  left: auto;
  top: -17px;
}

.tree li::before {
  border-left: 2px solid #999;
  bottom: 73px;
  height: 100%;
  top: -18px;
  width: 1px;
}

.tree li:last-child::before {
  height: 60px;
}

.tree > ul > li::before, .tree > ul > li::after {
  border: 0;
}


.tree li::after {
  border-top: 2px solid #999;
  height: 20px;
  top: 17px;
  width: 13px;
  right: -7px;
}

.tree > ul {
  margin: 0;
  padding: 0;
}

.tree ul ul {
  padding-right: 18px;
}

.tree li a {
  display: inline-block;
  white-space: nowrap;
}

.tree li a strong {
  position: relative;
  top: -17px;
  margin-right: 5px;
  display: inline-block;
  width: auto;
  white-space: nowrap;
}
</style>